import * as TabsPrimitive from '@radix-ui/react-tabs';
import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '@/shared/lib/utils';

type TabsListProps = ComponentPropsWithoutRef<typeof TabsPrimitive.List>;

export const TabsList = ({ className, ...props }: TabsListProps) => (
  <TabsPrimitive.List className={cn('inline-flex items-center gap-1.5', className)} {...props} />
);
